import { useState, useEffect, useRef  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcActionButton, CcCreateNewButton, CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import dayjs from 'dayjs';
import { InputText, LionListbox } from '../commonComponents/inputFields';
import { lionIcons } from '../components/helpersIcons';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ccColorDarkTeal } from '../components/helpersStyles';
import { CcLoader } from '../commonComponents/generalComponents';

const CustomColumnEditor = (props) => {
    const [metadata, setMetadata] = useState(undefined)
    const [dialogPreviewOpen, setDialogPreviewOpen] = useState(false)
    const [dialogPreviewData, setDialogPreviewData] = useState(undefined)
    const [dialogConfirmOpen, setDialogConfirmOpen] = useState(false)
    const [dialogConfirmData, setDialogConfirmData] = useState({})

    useEffect(() => {
        //console.log(props.functions)
        //console.log(props.metadata)
        //console.log(props.catalogColumns)
        if (props.metadata) setMetadata(props.metadata)
    }, [props.metadata])

  const getPreview = async () => {
    setDialogPreviewData(undefined)
    setDialogPreviewOpen(true)
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/DataFunctions/preview/catalog/${props.catalogId}`;
      const response = await axios.post(url, metadata.function);
      const data = response.data;

      setDialogPreviewData(data)

    } catch (error) {
      //console.log(error);
    }
  }

  const createColumn = async () => {
    const dialogData = {msg: <div className='text-ccColorDarkTeal'><div>A new column will be added to your catalog</div>
                              <div className='mt-2 text-sm'>You can start to use the new column immediately (e.g. in a Generator template) however allow some minutes to calculate the values for all the rows of your catalog</div>
                        </div>,
                        title:<div className='text-ccColorDarkTeal font-semibold text-xl'>Create new column</div>,
                        action: "createColumn"}
    setDialogConfirmData(dialogData)
    setDialogConfirmOpen(true)
  }

  const createColumn_Do = async () => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/DataFunctions/catalog/columns/create/${props.catalogId}`;
      const response = await axios.post(url, metadata);
      const data = response.data;

      handleMetadataChange('isNew', false)
      if (props.onChange) props.onChange(metadata)


    } catch (error) {
      //console.log(error);
    }
  }
  const deleteColumn = () => {
    const dialogData = {msg: <div className='text-ccColorDarkTeal'><div>Are you sure you want to delete the <span className='font-semibold'>{metadata.colName}</span> column?</div>
                              <div className='mt-2 text-sm'>By proceeding to delete this column all its data will be lost. Any data block connected to this column will be blank</div>
                        </div>,
                        title:<div className='text-ccColorDarkTeal font-semibold text-xl'>Delete column</div>,
                        action: "deleteColumn"}
    setDialogConfirmData(dialogData)
    setDialogConfirmOpen(true)

  }
  const deleteColumn_Do = async () => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/DataFunctions/catalog/columns/delete/${props.catalogId}`;
      const response = await axios.post(url, metadata);
      const data = response.data;

      if (props.onChange) props.onChange(metadata)

    } catch (error) {
      //console.log(error);
    }
  }
  const updateColumn = () => {
    const dialogData = {msg: <div className='text-ccColorDarkTeal'><div>Are you sure you want to update the <span className='font-semibold'>{metadata.colName}</span> column?</div>
                              <div className='mt-2 text-sm'>Updating a column can change its values for all the rows in your catalog.  Check that you are happy with the new values showing in your templates. If you are renaming a column, existing block might not work anymore and will be empty. If you are happy to proceed please allow some minutes for all the values to be calculated in your rows.</div>
                        </div>,
                        title:<div className='text-ccColorDarkTeal font-semibold text-xl'>Update column</div>,
                        action: "updateColumn"}
    setDialogConfirmData(dialogData)
    setDialogConfirmOpen(true)
  }
  const updateColumn_Do = async () => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/DataFunctions/catalog/columns/update/${props.catalogId}`;
      const response = await axios.post(url, metadata);
      const data = response.data;

      if (props.onChange) props.onChange(metadata)

    } catch (error) {
      //console.log(error);
    }
  }


    const handleMetadataChange = (propName, propValue) =>
    {
        const newMetadata = {...metadata, [propName]: propValue}

        console.log(newMetadata)
        setMetadata(newMetadata)
    }
    const handleFunctionPropertyChange = (propName, propValue) =>
    {
        const newFunction = {...metadata.function, [propName]: propValue}
        const newMetadata = {...metadata, function: newFunction}

        //console.log(newMetadata)
        setMetadata(newMetadata)
    }
    const handleFunctionChange = (functionName) =>
    {
        const newFunction = props.functions.find(f => f.functionName === functionName)

        const newMetadata = {...metadata, function: {name: functionName, parameters: newFunction.metadata.parameters}}

        setMetadata(newMetadata)
    }
    const handleFunctionParameterMappingChange = (index, paramValue) =>
    {
        const newParam = {...metadata.function.parameters[index], mappedColumn: paramValue}
        const newParameters = [...metadata.function.parameters]
        newParameters.splice(index, 1, newParam)

        handleFunctionPropertyChange('parameters', newParameters)
    }
    const handleFunctionParameterFixedValueChange = (index, paramValue) =>
    {
        const newParam = {...metadata.function.parameters[index], fixedValue: paramValue}
        const newParameters = [...metadata.function.parameters]
        newParameters.splice(index, 1, newParam)

        handleFunctionPropertyChange('parameters', newParameters)
    }
    const handlePreviewDialogClose = () => {
      setDialogPreviewOpen(false)
    }
    const handleConfirmDialogClose = async (action) => {
      if (action === 'createColumn') {
        await createColumn_Do()
      }
      else if (action === 'deleteColumn') {
        await deleteColumn_Do()
      }
      else if (action === 'updateColumn') {
        await updateColumn_Do()
      }
      setDialogConfirmOpen(false)
    }

    const renderPreviewData = () => {

      return <div>
        <div className='flex flex-row gap-x-0 items-center w-fit  text-ccColorDarkTeal font-semibold'>
          {metadata.function.parameters.map(p => <div className='w-48 px-2 py-1 bg-ccColorLightTeal text-center'>{p.name}</div>)}
          <div className='flex flex-row gap-x-0 items-center ml-4'>
            <hr class="w-[50px] border-[1px] border-ccColorDarkTeal"  />
            <div className='-ml-2'><Iconify icon="gravity-ui:arrow-up" width={22} rotate={45} /></div>
          </div>
          <div className='w-48 px-2 py-1 ml-2 bg-ccColorLightTeal text-center'>Result</div>
        </div>
        <div className='h-[480px] overflow-auto'>
        {dialogPreviewData.map((row, rowIndex) => <div className='flex flex-row gap-x-0 items-center w-fit text-ccColorDarkTeal'>
          {row.map((col, colIndex) => {return colIndex === row.length - 1 ? 
            <>
              <div className='flex flex-row gap-x-0 items-center ml-4'>
                <hr class="w-[50px] border-[1px] border-ccColorDarkTeal"  />
                <div className='-ml-2'><Iconify icon="gravity-ui:arrow-up" width={22} rotate={45} /></div>
              </div>
              <div className={`w-48 px-2 py-1 ml-2 text-center font-semibold ${rowIndex % 2 ? 'bg-gray-100' : 'bg-gray-200'}`}>{col}</div>
            </>
          :
          <div className={`w-48 px-2 py-1 text-center ${rowIndex % 2 ? 'bg-gray-100' : 'bg-gray-200'}`}>{col}</div>})

          }
          
        </div>)
        }
        </div>
      </div>
    }

    if (metadata === undefined) return <></>

    return <div className='flex flex-row gap-x-10 items-center mt-2 p-2 border rounded text-ccColorDarkTeal'>
            <div className='w-60 flex flex-col gap-y-2'>
               <InputText
                    displayName="Column name"
                    value={metadata.colName}
                    onChange={(val) => {handleMetadataChange('colName', val);}}
                    //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                />
                <div>
                  <div className="block text-sm font-medium text-gray-900">Type</div>
                  <LionListbox items={[{id: 'text', name: 'Text'}, {id: 'number', name: 'Number'}, {id: 'datetime', name: 'Date Time'}]}
                              selectedItemId={metadata.colType}
                              onChange={(item) => handleMetadataChange('colType', item.id)}
                              zIndex={1}
                  />
                </div>
            </div>
            <div className='w-60'>
                <div className="block text-sm font-medium text-gray-900">Apply function</div>
                <LionListbox items={props.functions.map(f => {return {id: f.functionName, name: f.functionPrettyName}})}
                            selectedItemId={metadata.function.name}
                            onChange={(item) => handleFunctionChange(item.id)}
                            zIndex={1}
                />
            </div>
            <div className='flex flex-col'>
                <div className="font-semibold">Parameters mapping</div>
                <div className="text-sm">Connect every parameter of the function to a field of your catalog</div>
                {metadata.function.parameters.map((p, index) => <div className='flex flex-row items-center gap-x-2 mt-2 h-14'>
                    <div className='w-[200px] bg-slate-100 rounded font-sourceCodePro px-2 py-1 text-center'>{p.name}</div>
                    <div className='w-12 ml-4'><Iconify icon="fontisto:arrow-h" width={26} /></div>
                    <div className='w-60'>
                        {props.catalogColumns &&
                            <LionListbox items={[{id:'', name:'Not connected'}, ...props.catalogColumns]}
                                    selectedItemId={metadata.function.parameters[index].mappedColumn}
                                    onChange={(item) => handleFunctionParameterMappingChange(index, item.id)}
                                    zIndex={20 * (props.zIndex +1) - index}
                            />
                        }
                    </div>
                    {metadata.function.parameters[index].mappedColumn === '' && <div className='w-32 -mt-6'>
                        <InputText
                            displayName="Fixed value"
                            value={metadata.function.parameters[index].fixedValue}
                            onChange={(val) => {handleFunctionParameterFixedValueChange(index, val);}}
                            //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />

                      </div>}
                </div>)}
            </div>
            <div className='flex flex-col gap-y-4'>
              <button className='flex flex-row items-center gap-x-2 bg-slate-200 rounded px-2 py-1 hover:bg-slate-400'
                      onClick={getPreview}
                >
                <Iconify icon={lionIcons.Icon_Actions_Preview} width={22} />
                <div>Preview</div>
              </button>
              {metadata.isNew ? 
                      <button className='flex flex-row items-center gap-x-2 bg-slate-200 rounded px-2 py-1 hover:bg-slate-400'
                        onClick={createColumn}>
                        <Iconify icon={lionIcons.Icon_Actions_Update} width={22} />
                        <div>Create</div>
                      </button>
                      :
                      <>
                      <button className='flex flex-row items-center gap-x-2 bg-slate-200 rounded px-2 py-1 hover:bg-slate-400'
                          onClick={updateColumn}>
                        <Iconify icon={lionIcons.Icon_Actions_Update} width={22} />
                        <div>Update</div>
                      </button>
                      <button className='flex flex-row items-center gap-x-2 bg-slate-200 rounded px-2 py-1 hover:bg-slate-400'
                           onClick={deleteColumn}>
                        <Iconify icon={lionIcons.Icon_Actions_Delete} width={22} />
                        <div>Delete</div>
                      </button>
                      </>
              }
            </div>


<Dialog onClose={() => handlePreviewDialogClose()} open={dialogPreviewOpen}
          maxWidth="lg"
          fullWidth>
      <DialogTitle id="dialog-title" sx={{color: ccColorDarkTeal}}>Preview</DialogTitle>
      <DialogContent>
          <DialogContentText id="dialog-description">
            <div className='h-[500px] flex justify-center'>
            {dialogPreviewData ? <div>{renderPreviewData()}</div>
            :
            <div className='mt-20 flex justify-center'>
              <CcLoader size={94} />
            </div>

            }
            </div>
            <div className='flex justify-end'>
              <CcActionButton onClick={() => handlePreviewDialogClose()}>Close</CcActionButton>
            </div>
            <div className='w-full h-4'></div>
          </DialogContentText>
        </DialogContent>

</Dialog>

<Dialog onClose={() => handleConfirmDialogClose()} open={dialogConfirmOpen}
          //maxWidth="md"
          >
      <DialogTitle id="dialog-title">{dialogConfirmData.title}</DialogTitle>
      <DialogContent>
          <DialogContentText id="dialog-description">
            <div className=' flex justify-center'>
              {dialogConfirmData.msg}
            </div>
            <div className='mt-4 gap-x-2 flex justify-end'>
              <CcActionButton onClick={() => handleConfirmDialogClose('abort')}>Cancel</CcActionButton>
              <CcActionButton onClick={() => handleConfirmDialogClose(dialogConfirmData.action)}>Submit</CcActionButton>
            </div>
            <div className='w-full h-4'></div>
          </DialogContentText>
        </DialogContent>

</Dialog>


        </div>
}

export default function PageCatalogCustomColumns() {
    const [showLoader, setShowLoader] = useState(true)
    const [catalogs, setCatalogs] = useState([]) //[{id: 1, name: ''}]
    const [selectedCatalogId, setSelectedCatalogId] = useState(0)
    const [columns, setColumns] = useState([]) //[{id: 1, name: ''}]
    const [functions, setFunctions] = useState([])
    const [catalogsMetadataDic, setCatalogsMetadataDic] = useState({}) // {catalogId: {metadata}}
    const [newColumnsCounter, setNewColumnsCounter] = useState(1) //only useed to give a name to a new column

    let params = useParams();
    
  useEffect(() => {
    getCatalogs()
    getFunctions()
  }, [])

  useEffect(() => {
      //console.log(params)
    if (params.catalogId !== undefined) {
        setSelectedCatalogId(parseInt(params.catalogId))
    }
  }, [params])

  useEffect(() => {
    const ids = Object.keys(catalogsMetadataDic)
    if (!ids.includes(selectedCatalogId.toString())) getCatalogMetadata(selectedCatalogId)
    getCustomColumnsMetadata(selectedCatalogId)
  }, [selectedCatalogId])

  const getCatalogs = async () => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Feeds/catalogs/names`;
      const response = await axios.get(url);
      const data = response.data;

      setCatalogs(data)
  


    } catch (error) {
      //console.log(error);
    }
  }
  const getFunctions = async () => {
      try {  
          const url = `${process.env.REACT_APP_LION_API_URL}/DataFunctions`;
          const response = await axios.get(url);
          const data = response.data;
          setFunctions(data)


      } catch (error) {
          console.log(error);
      }
  }
  const getCatalogMetadata = async (catalogId) => {
    if (catalogId === 0) return;

    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${catalogId}`;
      const response = await axios.get(url);
      const data = response.data;

      //we need to extract all visible columns
      const metadata = JSON.parse(data.metadata)
      const validColumns = Object.keys(metadata.columns).map(c => {return {id: c, name: c}})

      //console.log(data)
      const newCatalogMetadata = {...catalogsMetadataDic, [catalogId]: validColumns}
      //console.log(newCatalogMetadata)
      setCatalogsMetadataDic(newCatalogMetadata)
  


    } catch (error) {
      //console.log(error);
    }
  }
  const getCustomColumnsMetadata = async (catalogId) => {
    if (catalogId === 0) return;

    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/DataFunctions/catalog/columns/getmetadata/${catalogId}`;
      const response = await axios.get(url);
      let data = response.data;

      //we need to extract all visible columns
      //const metadata = JSON.parse(data.metadata)
      data = data.map(d => {return {...d, colOldName: d.colName}})
      if (data.length > 0) setColumns(data)


    } catch (error) {
      //console.log(error);
    }
    finally {setShowLoader(false)}
  }


  const handleCreateNewCustomColumn = () => {
    const defaultFunction = functions[0] //we take the first available function as a default value

    //we need to add "mappedColumn" to every parameter from the default function
    const parametersWithMappedProp = defaultFunction.metadata.parameters.map(p => {return {...p, mappedColumn: '', fixedValue: ''}})
    const newColumn = {colName: `NewColumn${newColumnsCounter}`, colOldName: `NewColumn${newColumnsCounter}`, colType: 'text', isNew: true, function: {name: defaultFunction.functionName, parameters: parametersWithMappedProp}}

    setNewColumnsCounter(newColumnsCounter +1)
    const newColumns = [...columns, newColumn]
    setColumns(newColumns)
  }

  const handleColumnChange = (col) => {
    setShowLoader(true)
    getCustomColumnsMetadata(selectedCatalogId)
  }

    return <div>
            <CcTitle>Manage Custom Columns</CcTitle>
            <div className="text-ccColorDarkTeal">You can create new columns to your Catalogs. The values in the columns are defined by custom functions</div>

            {!showLoader && catalogs.length === 0 && <div className='mt-8 text-ccColorDarkTeal'>
                <div className='font-semibold text-xl'>No catalogs defined</div>
                <div>Create a catalog first</div>
            </div>
            }
            {!showLoader && catalogs.length > 0 && <>
            <div className='mt-6'>
                <div className="block text-sm font-medium text-gray-900">Catalog</div>
                <LionListbox items={catalogs}
                            selectedItemId={selectedCatalogId}
                            onChange={(item) => setSelectedCatalogId(item.id)}
                            zIndex={1}
                />
                
            </div>
            {columns.map((c, index) => <CustomColumnEditor metadata={c} 
                                            functions={functions} zIndex={index} 
                                            catalogColumns={catalogsMetadataDic[selectedCatalogId]}
                                            catalogId={selectedCatalogId}
                                            onChange={handleColumnChange}
                                            />)

            }
            <div className='mt-2'>
                <CcCreateNewButton onClick={handleCreateNewCustomColumn}>Add new custom column</CcCreateNewButton>
            </div>
            </>
            }
            {showLoader && <div className='flex flex-col items-center mt-20 gap-y-1'>
              <CcLoader size={96} />
              <div className='text-ccColorDarkTeal font-poppins text-sm font-semibold'>Loading columns</div>
              </div>
            }
    </div>
}